import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import iView from 'view-design'
import { setToken, getToken, setTitle } from '@/libs/util'
import { oneOf } from '@/libs/tools'
import { filterAsyncRouter } from '@/libs/router-utils'

Vue.use(Router)
const createRouter = () => new Router({
  routes
})

const router = createRouter()

// 路由切换前的菜单兜底恢复：若 vuex 是新建的且 sessionStorage 里有动态菜单，
// 立即同步到 state.menuList 并 addRoutes，避免"新窗口/刷新进后台 → 左侧菜单空白"。
const ensureMenuRestored = () => {
  if (store.state.app.menuList.length > 0) return
  const cached = sessionStorage.getItem('dynamicRouter')
  if (!cached) return
  try {
    const raw = JSON.parse(cached)
    if (Array.isArray(raw) && raw.length > 0) {
      store.commit('updateMenuList', filterAsyncRouter(raw))
    }
  } catch (e) {
    console.warn('[router] ensureMenuRestored 解析失败：', e)
  }
}

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  ensureMenuRestored()
  const token = getToken()
  if (to.name.indexOf('wiki_') === -1) {
    if (!token && to.name !== 'login') {
      // 未登录且要跳转的页面不是登录页
      next({
        name: 'login'
      })
    } else if (!token && to.name === 'login') {
      // 未登陆且要跳转的页面是登录页
      next()
    } else if (token && to.name === 'login') {
      // 已登录且要跳转的页面是登录页
      next({
        name: 'home'
      })
    } else {
      // 有token，尝试获取用户信息
      store.dispatch('getUserInfo').then(user => {
        // 路由中有相关配置才会识别并且鉴权，否则认为不需要鉴权
        if (to.meta && to.meta.access) {
          if (oneOf(to.meta.access, user.access)) {
            // 有权限，可访问
            next()
          } else {
            // 无权限，重定向到401页面
            next({ replace: true, name: 'error_401' })
          }
        } else {
          next()
        }
      }).catch((error) => {
        console.error('获取用户信息失败:', error)
        // API请求失败，清除token并跳转到登录页
        setToken('')
        next({
          name: 'login'
        })
      })
    }
  } else {
    if (!token && to.name !== 'wiki_login') {
      // 未登录且要跳转的页面不是登录页
      next({
        name: 'wiki_login'
      })
    } else if (!token && to.name === 'wiki_login') {
      // 未登陆且要跳转的页面是登录页
      next()
    } else if (token && to.name === 'wiki_login') {
      // 已登录且要跳转的页面是登录页
      next({
        name: 'wiki_list'
      })
    } else {
      next()
    }
  }
})

router.afterEach(to => {
  setTitle(to, router.app)
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // the relevant part
}

export default router
